module.exports = __webpack_public_path__ + "static/media/SM-MT-intro-AFTER-trial-exercise.463cd33f.mp3";